export const NOTICES: { [key: string]: string } = {
    ACCOUNT_EXISTS: 'Account already exists',
    ACCOUNT_NOT_ACTIVE: 'Account is not active',
    AUTH: 'Authentication error',
    STOCK: 'Product is out of stock',
    ERROR: 'Unexpected error',
    INVALID: 'Invalid data provided',
    INVALID_COUPON: 'Invalid coupon code',
    INVALID_GIFTCARD: 'Invalid gift card code',
    LOGGEDIN: 'You are already logged in',
    LOGGEDOUT: 'You are not logged in',
    LOCATION: `Unfortunately, we couldn't find any of our stores near this area.
		If you are searching for one of our UK stores, please try another search
		containing a postcode or town name; for our international locations, please type in a city name.`,
    MISSING: 'Please fill all required fields',
    OPTIONS: 'Please select all required options',
    REQUEST: 'Invalid request',
    COUPON_REMOVED: 'Coupon code has been removed',
    SESSION_EXPIRED: 'Session expired',
    SUCCESS: 'Data saved',
    NOTEXIST: 'Account does not exist',
    USED: "You can't set e-mail address to this one",
    SUBSCRIBED: 'You are subscribed already',
    INVALIDFIELD: 'This field is not valid.',
    REQUIREDFIELD: 'This is a required field.',
    INVALIDPOSTCODE: 'This postcode is not valid.',
    INVLIDEMAILFIELD: 'Please enter valid email address.',
    INVLIDPHONEFIELD: 'Please enter telephone number.',
    NOTMATCHED: 'Passwords are not the same.',
    EMOJIDETECTED: 'Using Emojis is not allowed',
    500: 'Unexpected exception (500)',
    502: 'Unexpected server problem (502)',
    504: 'Connetion timed out'
};
